export default __webpack_public_path__ + "static/media/naidi-6-2.a8bf709b.svg";